import React from 'react';
import { Typography, Box, Grid } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import SetPageTitle from 'components/Portals/SetPageTitle';
import { useTranslation } from 'services/localization';
import {
	getAddOnDetails,
	getInstalledAddOnsForShop,
	isAddOnVisible,
} from 'common/modules/plans/add-ons';
import * as ShopSelectors from 'selectors/ShopSelectors';
import { useSelector } from 'react-redux';
import EmptyState from 'common/components/EmptyState';
import AddOnCard from './components/BlockCard';
import { chain } from 'lodash';

const InstalledBlocks = () => {
	const { t } = useTranslation();
	const classes = useStyles();
	const shopFeatures = useSelector(ShopSelectors.shopFeatures);
	const installedAddOns = getInstalledAddOnsForShop(shopFeatures);

	const filteredInstalledAddOns = chain(installedAddOns)
		.filter((addOn) => isAddOnVisible(addOn))
		.sortBy((addOn) => getAddOnDetails(addOn, t).name)
		.value();

	return (
		<>
			<SetPageTitle priority={2} title={t('account.addOns.pageTitle')} />

			<EmptyState
				isEmpty={filteredInstalledAddOns.length === 0}
				isLoading={false}
				emptyContent={
					<Box className={classes.centerText}>
						<Typography variant="h5">
							{t('account.addOns.noInstalledAddOns', 'You have no installed blocks')}
						</Typography>
						<Typography className={classes.secondaryText} variant="body1">
							{t(
								'account.addOns.noInstalledAddOnsDescription',
								"Once you install a block, it'll be visible here",
							)}
						</Typography>
					</Box>
				}
				render={() => (
					<Grid container spacing={3}>
						{filteredInstalledAddOns.map((addOn) => (
							<Grid key={addOn} item xs={12} md={4}>
								<AddOnCard addOn={addOn} />
							</Grid>
						))}
					</Grid>
				)}
			/>
		</>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			marginTop: theme.spacing(4),
			paddingLeft: theme.spacing(6),
			paddingRight: theme.spacing(6),
		},
		centerText: {
			textAlign: 'center',
			margin: theme.spacing(2),
		},
		secondaryText: {
			opacity: 0.5,
			margin: theme.spacing(1),
		},
	}),
);

export default InstalledBlocks;
